import {SlideShowTouch, displaySlideHome, SlideShowOverlay, displaySlideArticle, Slideshow} from './module/slideshow'
import {useClosest, useArrayFrom, useSvg} from './module/polyfill'
import {reveal} from './module/scrollreveal'
import {contactMap, programsMap} from './module/map'
import Form from './module/form'
import { Dropdown } from './module/dropdown'
import { openFiltersContainer, openSubFilters, closeSubFilters, closeFiltersContainer, submitFilters, checkFilter } from './module/filters'
import { RangerSlider } from './module/slider'

(function () {

	let body = document.body

	useSvg()
	useArrayFrom()
	useClosest()

	/**
	 * Scroll reveal
	 */
	if (document.querySelector('.target-hidden'))
		reveal()

	/**
	 * Mapbox instances
	 */
	if (document.querySelector('.map__contact') || document.querySelector('.program__map'))
		contactMap()

	if (document.querySelector('.offercard__map'))
		programsMap()

	/**
	 * Form instances
	 */
	if (document.querySelector('.contact-form')) {
		const formsNode = document.querySelectorAll('.contact-form')
		formsNode.forEach((formNode) => {
			const form = new Form(formNode)
			form.registerEvents()
		})        
	}

	/**
	 * Slideshow instances
	 */
	if (document.querySelector('.slideshow')) {
		let slideshow = new Slideshow(document.querySelector('.slideshow'))
		slideshow.init()
	}

	if (document.querySelector('.hero-overlay')) {
		let slideshow = new SlideShowOverlay(document.querySelector('.hero-overlay'), document.querySelector('.slideshow__overlay'))
		slideshow.registerEvents()
	}

	/**
	 * Dropdown instances
	 */

	/**
	 * Homepage dropdown
	 */
	if (document.querySelector('.dropdown')) {

		let dropdowns = document.querySelectorAll('.dropdown'),
			lng       = dropdowns.length,
			i
		for (i=0; i<lng; i++) {
			let dropdown = new Dropdown(dropdowns[i])
			dropdown.init()
		}
	}

	/**
	 * Select input emulator
	 */
	const openDropDown = el => {
		el.nextElementSibling.classList.toggle('trigger')
	}

	const selectValue = el => {

		let parent  = el.closest('.selector'),
			trigger = parent.querySelector('.selector-trigger'),
			input   = parent.querySelector('input')
		
		trigger.innerHTML = el.getAttribute('data-value')
		input.value = el.getAttribute('data-value')
		el.parentElement.classList.remove('trigger')
	}

	/**
	 * Navigation
	 */
	const triggerNavbar = el => {
		el.classList.toggle('trigger')
		document.querySelector('.menu').classList.toggle('trigger')
		body.classList.toggle('trigger')
	}

	const closeNavbar = () => {
		document.querySelector('.menu').classList.remove('trigger')
		body.classList.remove('trigger')
	}

	const handleNavbar = () => {
		let navbar = document.querySelector('.navbar')

		if (window.scrollY > 0 && !navbar.classList.contains('scrolled'))
			return navbar.classList.add('scrolled')
		if (window.scrollY === 0 && navbar.classList.contains('scrolled'))
			return navbar.classList.remove('scrolled')
	}
	if (document.querySelector('.navbar'))
		handleNavbar()

	/**
	 * Slideshow popup
	 */
	const openPopup = el => el.classList.add('trigger')
	
	const closePopup = () => document.querySelector('.popup__open.trigger').classList.remove('trigger')
	
	const displayPopupSlide = el => {
		let container = el.closest('.popup'),
			slides    = Array.from(container.querySelectorAll('.popup__img')),
			current   = container.querySelector('.popup__img.trigger'),
			indexOf   = slides.indexOf(current),
			direction = el.classList.contains('previous') ? -1 : 1

		indexOf = indexOf + direction

		if (indexOf < 0) indexOf = slides.length - 1
		if (indexOf === slides.length) indexOf = 0

		current.classList.remove('trigger')
		slides[indexOf].classList.add('trigger')
	}

	const displayFitlersMode = el => {
		el.classList.toggle('trigger')
		document.querySelector('.offercard__container').classList.toggle('list')
	}

	/**
	 * Range Slider
	 */
	if (document.querySelector('.slider')) {
		let slider 		 = document.querySelector('.slider'),
			rangerSlider = new RangerSlider(slider)

		rangerSlider.init()

		const updateValues = (min, max) => {
			document.querySelector('.slider-value-min').value = Math.round(min / 500) * 500
			document.querySelector('.slider-value-max').value = Math.round(max / 500) * 500
		}
	
		rangerSlider.onChange = function (min, max) {
			updateValues(min, max)
		}
	
		rangerSlider.didChanged = function (min, max) {
			updateValues(min, max)
		}
	}

	/**
	 * Tab content
	 */
	const displayTabArrow = el => {
		
		let container 	  = el.closest('.tab-container'),
			tabs      	  = Array.from(container.querySelectorAll('.tab-content')),
			current   	  = container.querySelector('.tab-content.trigger'),
			indexOf   	  = tabs.indexOf(current),
			direction 	  = (el.classList.contains('previous')) ? -1 : 1,
			bullets   	  = container.querySelectorAll('.tab-bullet')

		bullets[indexOf].classList.remove('trigger')
			
		indexOf = indexOf + direction

		if (indexOf < 0) indexOf = tabs.length - 1
		if (indexOf === tabs.length) indexOf = 0

		current.classList.remove('trigger')
		tabs[indexOf].classList.add('trigger')
		bullets[indexOf].classList.add('trigger')
	}

	const displayTabBullet = el => {

		let container = el.closest('.tab-container'),
			bullets   = Array.from(container.querySelectorAll('.tab-bullet')),
			current   = container.querySelector('.tab-bullet.trigger'),
			indexOf   = bullets.indexOf(current),
			tabs      = container.querySelectorAll('.tab-content')

		tabs[indexOf].classList.remove('trigger')
		current.classList.remove('trigger')

		indexOf = bullets.indexOf(el)
		
		bullets[indexOf].classList.add('trigger')
		tabs[indexOf].classList.add('trigger')
	}

	/**
	 * Events
	 */
	window.addEventListener('scroll', () => {
		if (document.querySelector('.navbar'))
			handleNavbar()
	})
    
    body.addEventListener('click', (e) => {

		let el = e.target

		if (!el.classList.contains('selector-opt-item') && document.querySelector('.selector__opt.trigger'))
			document.querySelector('.selector__opt.trigger').classList.remove('trigger')

        if (el.classList.contains('slideshow-home-item'))
			return displaySlideHome(el)
			
		if (el.classList.contains('menu-trigger'))
			return triggerNavbar(el)

		if (el.classList.contains('menu-close'))
			return closeNavbar()

		if (el.classList.contains('tab-arrow'))
			return displayTabArrow(el)

		if (el.classList.contains('tab-bullet'))
			return displayTabBullet(el)

		if (el.classList.contains('selector-trigger'))
			return openDropDown(el)

		if (el.classList.contains('selector-opt-item'))
			return selectValue(el)

		if (el.classList.contains('filters__sp__filter--trigger'))
			return openSubFilters(el)

		if (el.classList.contains('filters__sp__filter--close'))
			return closeSubFilters()

		if (el.classList.contains('filters__sp__checkbox'))
			return checkFilter(el)

		if (el.classList.contains('filters__sp__submit'))
			return submitFilters()

		if (el.classList.contains('filters__sp__open'))
			return openFiltersContainer()

		if (el.classList.contains('filters__sp__close'))
			return closeFiltersContainer()

		if (el.classList.contains('popup__open'))
			return openPopup(el)

		if (el.classList.contains('popup__controller'))
			return displayPopupSlide(el)

		if (el.classList.contains('popup__close'))
			return closePopup()

		if (el.classList.contains('filters__display__item'))
			return displayFitlersMode(el)

		if (el.classList.contains('article__controller'))
			return displaySlideArticle(el)

		if (el.classList.contains('menu-search'))
			return document.querySelector('.modal__search').classList.add('trigger')
		if (el.classList.contains('menu-search-close'))
			return document.querySelector('.modal__search').classList.remove('trigger')
	})
	
})()

